import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import "./ShowRoomBaghdadArt.css";

import { LanguageContext } from "../../context/LanguageContext";

const ShowRoomBaghdadArt = () => {
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const { currentLang } = useContext(LanguageContext);

  const [data, setData] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/ShowRoomBaghdadArt?lang=${currentLang}`
        );
        setData(res.data);
      } catch (err) {
        console.error("Failed to load ShowRoomBaghdadArt:", err);
      }
    };

    loadData();
  }, [API_BASE, currentLang]);

  if (!data) {
    return <div className="art-loading">Loading...</div>;
  }

  return (
    <section className="art-section">
      {/* ===== BIG IMAGE TOP ===== */}
      <div className="art-big-img-wrapper">
        <img
          src={`${API_BASE}${data.bigImageTop}`}
          alt="Showroom Top"
        />
      </div>

    
    </section>
  );
};

export default ShowRoomBaghdadArt;
